import { IState } from "@/redux/store.types";
import { getValueState } from "@/redux/utils";

import { $WishlistSidebarModuleName } from "./wishlistSidebar.types";

export const isSidebarVisible = (state: IState) =>
    !!getValueState(state, $WishlistSidebarModuleName)?.visible;

export const getCurrentListId = (state: IState) =>
    getValueState(state, $WishlistSidebarModuleName)?.currentListId;
